/**
 * Detects the scrollbar width in pixels.
 * Creates a temporary scrollable element to measure the difference between
 * offsetWidth (includes scrollbar) and clientWidth (excludes scrollbar).
 * Returns 0 for overlay scrollbars (macOS default) or the actual width (typically 15-17px on Windows/Linux).
 * The probe element forces a synchronous layout, so the result is measured once per page
 * and reused by every later caller (the nav popovers ask on each open).
 */
let cachedScrollbarWidth = null

export function getScrollbarWidth() {
  if (typeof document === 'undefined') return 0

  if (cachedScrollbarWidth !== null) return cachedScrollbarWidth

  const div = document.createElement('div')
  div.style.width = '100px'
  div.style.height = '100px'
  div.style.overflow = 'scroll'
  div.style.position = 'absolute'
  div.style.top = '-9999px'

  document.body.appendChild(div)
  cachedScrollbarWidth = div.offsetWidth - div.clientWidth
  document.body.removeChild(div)

  return cachedScrollbarWidth
}

// Test-only: module-level cache would otherwise leak between specs.
export function resetScrollbarWidthCache() {
  cachedScrollbarWidth = null
}
